<lib-event-page [startTime]="startTime!" [eventId]="id"></lib-event-page>